import Modal from "@via/components/modal.tsx";
import { ButtonColor } from "@via/utils/constants.tsx";
import { type FC } from "react";
import { useDemoteDataSource } from "@via/pages/data/data-connections/data-connections.api.tsx";

interface DemoteBookmarkItemModalProps {
  bookmarkedItem: { name: string; id: number } | null;
  setBookmarkedItem: (
    bookmarkedItem: { name: string; id: number } | null
  ) => void;
}

/** Confirms making a data source read-only, which cannot be undone from the product (3G-2d). */
const DemoteBookmarkItemModal: FC<DemoteBookmarkItemModalProps> = ({
  bookmarkedItem,
  setBookmarkedItem,
}) => {
  const { mutateAsync: demoteDataSource, isPending: isDemoteLoading } =
    useDemoteDataSource();

  return (
    <Modal
      open={!!bookmarkedItem}
      setOpen={() => {
        setBookmarkedItem(null);
      }}
      title="Make Data Source Read-Only"
      confirmText="Make read-only"
      confirmButtonColor={ButtonColor.Red}
      isConfirmLoading={isDemoteLoading}
      onConfirm={() => demoteDataSource(bookmarkedItem?.id.toString())}>
      <div className="flex flex-col gap-2 py-2 text-sm leading-6 text-slate-600 md:py-3 lg:py-4">
        <p>
          Make <span className="font-semibold">{bookmarkedItem?.name}</span>{" "}
          read-only?
        </p>
        <p>
          Runs on agent run environments can only read from read-only data
          sources. Once it is read-only, Foundry Connect will not write to it.
          This cannot be undone.
        </p>
      </div>
    </Modal>
  );
};

export default DemoteBookmarkItemModal;
